import tableDictionaryItems from './tableDictionaryItems';

export default {
  title: 'Dictionary Items',
  attributeName: 'appDictionaryItems',
  getURL: 'appId/appDictionaryItemsPlay',
  createURL: 'appId/appDictionaryItemsPlay',
  updateURL: 'appId/appDictionaryItemsPlay',
  removeURL: 'appId/appDictionaryItemsPlay',
  sessionParams: ['appId'],
  noArea: true,
  removeNameField:'key',
  removeText:'You are about to remove the Dictionary item with key ##key##.',
  tableConfig: tableDictionaryItems,
  autoUpdate: true,
};
